/**
 * Rótulos dos ambientes Astrea, usados para comparação (ex:
 * `useCurrentUser.js`'s "não é PROD" checks). A resolução de qual
 * ambiente está ativo e qual sua URL é feita pelo servidor, fixa por deploy
 * (`ASTREA_ENVIRONMENT`) — ver `server_app/helpers/astreaEnvironment.js` e
 * `shared/hooks/useAstreaEnvironment.js` (que expõe `urlAstrea`/
 * `urlAstreaPath` já resolvidos, sem precisar de um mapa local aqui).
 */
export const ASTREA_ENVIRONMENTS = {
  PRODUCTION: 'PROD',
  LOCAL: 'LOCAL',
  HOMOLOGATION: 'HOMOLOG',
  PLAYGROUND: 'PLAYGROUND',
}
